import type { ReadConfig } from 'api-read-hook';
import type { HydraCollection } from '../../types';

import { useApiRead } from 'api-read-hook';

export type BaseView = {
  '@id': string;
  '@type': 'ServiceOrder';
  id: string;
  name: string;
  referenceNumber: string | null;
  budget: number | null;
  dayLimit: string | null;
  finishDate: string | null;
};

export type V_List = {
  '@id': string;
  '@type': 'ServiceOrder';
  id: string;
  company: string;
  project: string | null;
  stages: Array<{
    '@id': string;
    '@type': 'ServiceOrderStage';
    id: string;
    name: string;
    startDate: string | null;
    estimatedFinishDate: string | null;
    finishDate: string | null;
  }>;
  name: string;
  referenceNumber: string | null;
  budget: number | null;
  dayLimit: string | null;
  finishDate: string | null;
};

export type W = {
  company: string;
  project: string | null;
  stages: Array<{
    name: string;
    startDate: string | null;
    estimatedFinishDate: string | null;
    finishDate: string | null;
  }>;
  name: string;
  referenceNumber: string | null;
  budget: number | null;
  dayLimit: string | null;
};

export function useReadCollection(options?: ReadConfig) {
  return useApiRead<HydraCollection<V_List>>(`/service-orders`, options);
}

export function useReadCollectionServiceOrders(
  companyId: string,
  options?: ReadConfig
) {
  return useApiRead<HydraCollection<V_List>>(
    `/companies/${companyId}/service-orders`,
    options
  );
}

export function useReadItem(id: string, options?: ReadConfig) {
  return useApiRead<V_List>(`/service-orders/${id}`, options);
}
